import styled from '@emotion/styled';
import { Divider } from '@mui/material';

const Container = styled.div<{ show: boolean }>`
    width: 100%;
    display: ${({ show }) => (show ? 'flex' : 'none')};
    justify-content: center;
    align-items: center;
    flex-direction: row;
`;

const StyledDivider = styled(Divider)<{ isCurrStep: boolean }>`
    display: flex;
    width: 36px;
    height: 14px;
    align-items: flex-start;
    border-radius: 40px;
    background: ${({ isCurrStep, theme }) => (isCurrStep ? theme.colors.secondary.main : theme.colors.black[100])};
    border-bottom: none;
    margin-top: 12px;
    margin-bottom: 20px;
    margin-right: 7px;
`;

type Props = {
    size: number;
    currStep: number;
    show: boolean;
};

export default function NewProgressStepper({ size, currStep, show }: Props) {
    const dividers = Array(size + 1).fill(false);
    const dividersArray = dividers.map((_, index) => index === currStep - 1);

    return (
        <Container show={show}>
            {dividersArray.map((_, i) => (
                <StyledDivider isCurrStep={dividersArray[i]} key={i} />
            ))}
        </Container>
    );
}
